import { useState, type PropsWithChildren } from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { type TableState } from "@features/sales-v4/types";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { type SalesMetricRow } from "@north-beam/nb-common";
import { generateAnonBase64Hash } from "@utils/anonymous";
import { usePrefs } from "@utils/client-side-preferences";

import { TooltipMetricsTable } from "../tooltip-metrics-table";

export const Tooltip = ({
  metric,
  row,
  tableState,
  rowItemName,
  children,
}: PropsWithChildren<{
  metric: SalesMetricV2;
  row: SalesMetricRow;
  tableState: TableState;
  rowItemName: string;
}>) => {
  const { isDemoMode } = usePrefs();
  const [isLoading, setIsLoading] = useState(true);

  const tooltipRowMetadata = [
    { metricId: "aov" },
    { metricId: "aovFt" },
    { metricId: "aovRtn" },
  ];

  return (
    <GenericTooltip
      noInfoCircle
      overlayClassName={clsx(
        "p-0 rounded-lg border-none shadow-[0_4px_8px] shadow-v2-black/15%",
      )}
      arrowClassName="bg-v2-cosmic/50"
      placement="top"
      mouseEnterDelay={500}
      content={
        <div className="p-4 bg-v2-secondary rounded-lg text-v2-primary">
          <div className="mb-2">
            <div className="text-sm font-semibold mb-1.5">
              {metric.name}:{" "}
              {isDemoMode &&
              tableState.selectedTab !== "breakdown" &&
              rowItemName !== "Grand Total"
                ? generateAnonBase64Hash({
                    value: rowItemName,
                    prefix: tableState.selectedTab,
                    doAnon: isDemoMode,
                  })
                : rowItemName}
            </div>
          </div>
          <TooltipMetricsTable
            row={row}
            tableState={tableState}
            setIsLoading={setIsLoading}
            metricIds={["aov", "aovFt", "aovRtn"]}
            tooltipRowMetadata={tooltipRowMetadata}
          />
        </div>
      }
    >
      <div
        className={clsx({
          "cursor-wait": isLoading,
          "cursor-default": !isLoading,
        })}
      >
        {children}
      </div>
    </GenericTooltip>
  );
};
